import React from 'react';
import {
  detailOverlayStyle,
  detailOverlayWebExtra,
  rowDetailStyle,
  rowDetailWebExtra,
  dcmActionsStyle
} from './styles';
import { MCButton, MCText, View } from 'components/basic';
import { humanFileSize, lang } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

// Template 1: translucent dark bar overlaid on the bottom of the preview, name centered, white text.
// Template 2: plain row to the right of a small thumbnail, name left-aligned, normal text color.
// scss: .mc-file-box__detail_name { font: 400 18/24; } — regular weight in both templates.
function FileDetail({
  file,
  showFileName = false,
  showFileSize = false,
  isDcm = false,
  expired = false,
  template = 1,
  onClick,
  onSave,
  onView
}) {
  if (!showFileName) return null;

  const fileSize = file?.size || file?.file?.size || 0;
  const isOverlay = template !== 2;

  const handleClick = () => {
    if (isDcm || expired) return; // DICOM has its own buttons; an expired file has nothing to open
    onClick && onClick();
  };

  const containerStyle = isOverlay
    ? { ...detailOverlayStyle, ...detailOverlayWebExtra }
    : { ...rowDetailStyle, ...rowDetailWebExtra };
  if (isDcm) {
    containerStyle.flexDirection = 'row';
    containerStyle.justifyContent = 'space-between';
  }

  const textAlign = isOverlay ? 'center' : 'left';

  return (
    <View onClick={handleClick} style={containerStyle}>
      <View style={{ alignItems: isOverlay ? 'center' : 'flex-start' }}>
        <MCText
          data-testid='file-box-name'
          text={!isOverlay && !expired}
          white={isOverlay && !expired}
          textLight={expired}
          weight={400}
          size={18}
          numberOfLines={1}
          style={{ textAlign, width: '100%' }}
        >
          {expired ? lang.t(LANG_CONST.text.file_expired) : file?.name || file?.originalName}
        </MCText>
        {!expired && showFileSize && fileSize > 0 && (
          <MCText
            textLight={!isOverlay}
            white={isOverlay}
            weight={400}
            size={16}
            style={{ textAlign, marginTop: 2 }}
          >
            {humanFileSize(fileSize)}
          </MCText>
        )}
      </View>

      {isDcm && !expired && (
        <View
          style={{
            ...dcmActionsStyle,
            alignSelf: isOverlay ? 'center' : 'flex-start'
          }}
        >
          <MCButton
            label='Save'
            small
            primary
            radius
            dark
            title='Download DICOM'
            onClick={onSave}
          />
          <MCButton
            label='View'
            small
            primary
            radius
            dark
            title='Open in OHIF Viewer'
            onClick={onView}
          />
        </View>
      )}
    </View>
  );
}

export default FileDetail;
